var _g;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgIconSlope(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 201.355 83.276"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    "data-name": "Group 46"
  }, /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 235",
    d: "M200.707 82.63c-4.248-1.669-3.355-4.152-6.761-5.951-4.62-2.44-10.754-.115-15.251-2.773-2.929-1.732-4.576-5.29-7.739-6.541-3.114-1.232-6.8.152-9.912-1.094-3.027-1.214-4.719-4.6-7.7-5.926-3.457-1.532-7.717.112-11.153-1.468-3.154-1.45-4.653-5.164-7.572-7.044-2.473-1.593-5.456-1.732-8.305-1.527-3.57.258-6.818 2.293-9.806-.518-2.5-2.35-3.9-6.055-7.3-7.331-3.581-1.341-7.559.887-11.331.275-5.86-.952-8.873-8.119-14.574-9.789-2.8-.82-5.793-.167-8.695-.43a13.909 13.909 0 01-8.268-3.755c-2.725-2.6-4.972-6.612-8.738-6.608a27.1 27.1 0 00-3.707.671c-3.422.483-6.8-1.507-9.089-4.1-1.834-2.082-3.612-4.83-6.389-4.929-2.472-.088-4.773 2.1-7.154 1.408-3.152-.911-3.145-5.66-5.8-7.588-3.444-2.5-8.63 1.287-12.409-.678-2.222-1.157-3.114-3.908-5.126-5.4a5.685 5.685 0 00-7.222.576v80.52z",
    fill: "#c9c9c9"
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 236",
    d: "M200.707 82.63c-4.248-1.669-3.355-4.152-6.761-5.951-4.62-2.44-10.754-.115-15.251-2.773-2.929-1.732-4.576-5.29-7.739-6.541-3.114-1.232-6.8.152-9.912-1.094-3.027-1.214-4.719-4.6-7.7-5.926-3.457-1.532-7.717.112-11.153-1.468-3.154-1.45-4.653-5.164-7.572-7.044-2.473-1.593-5.456-1.732-8.305-1.527-3.57.258-6.818 2.293-9.806-.518-2.5-2.35-3.9-6.055-7.3-7.331-3.581-1.341-7.559.887-11.331.275-5.86-.952-8.873-8.119-14.574-9.789-2.8-.82-5.793-.167-8.695-.43a13.909 13.909 0 01-8.268-3.755c-2.725-2.6-4.972-6.612-8.738-6.608a27.1 27.1 0 00-3.707.671c-3.422.483-6.8-1.507-9.089-4.1-1.834-2.082-3.612-4.83-6.389-4.929-2.472-.088-4.773 2.1-7.154 1.408-3.152-.911-3.145-5.66-5.8-7.588-3.444-2.5-8.63 1.287-12.409-.678-2.222-1.157-3.114-3.908-5.126-5.4a5.685 5.685 0 00-7.222.576",
    fill: "none",
    stroke: "#161615",
    strokeLinecap: "round",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 237",
    d: "M13.036 25.844a3.277 3.277 0 01.784-.542 7.159 7.159 0 013.6-.522 8.907 8.907 0 013.241.652c2.225 1.011 2.942 3.59 3.083 5.841.155 2.486-11.489 3.861-11.774-1.718a4.573 4.573 0 011.066-3.711z",
    fill: "none",
    stroke: "#040405",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 238",
    d: "M47.144 34.647a1.646 1.646 0 01-.056-.473 3.581 3.581 0 01.61-1.712 4.451 4.451 0 011.046-1.28 3.229 3.229 0 013.3 0c1.135.513-.981 5.98-3.513 4.8a2.285 2.285 0 01-1.387-1.335z",
    fill: "none",
    stroke: "#040405",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 239",
    d: "M34.857 53.172a3.291 3.291 0 01.783-.542 7.161 7.161 0 013.6-.522 8.886 8.886 0 013.241.653c2.225 1.01 2.942 3.589 3.083 5.84.156 2.488-11.489 3.861-11.773-1.718a4.573 4.573 0 011.066-3.711z",
    fill: "none",
    stroke: "#040405",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 240",
    d: "M72.86 46.116a3.277 3.277 0 01.784-.542 7.16 7.16 0 013.6-.522 8.887 8.887 0 013.241.653c2.225 1.01 2.942 3.59 3.083 5.84.155 2.487-11.489 3.861-11.774-1.718a4.573 4.573 0 011.066-3.711z",
    fill: "none",
    stroke: "#040405",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 241",
    d: "M57.642 75.232a1.646 1.646 0 01-.056-.473 3.581 3.581 0 01.61-1.712 4.451 4.451 0 011.046-1.28 3.229 3.229 0 013.3 0c1.136.513-.981 5.98-3.513 4.8a2.285 2.285 0 01-1.387-1.335z",
    fill: "none",
    stroke: "#040405",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 242",
    d: "M103.911 61.173a3.27 3.27 0 01.783-.542 7.159 7.159 0 013.6-.522 8.887 8.887 0 013.241.653c2.225 1.01 2.942 3.589 3.083 5.84.156 2.488-11.489 3.861-11.774-1.718a4.57 4.57 0 011.067-3.711z",
    fill: "none",
    stroke: "#040405",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 243",
    d: "M138.048 72.517a1.682 1.682 0 01-.056-.473 3.572 3.572 0 01.611-1.712 4.434 4.434 0 011.046-1.28 3.227 3.227 0 013.3 0c1.136.513-.981 5.98-3.513 4.8a2.285 2.285 0 01-1.388-1.335z",
    fill: "none",
    stroke: "#040405",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 244",
    d: "M8.285 50.577a1.6 1.6 0 01-.056-.473 3.589 3.589 0 01.61-1.712 4.465 4.465 0 011.046-1.28 3.227 3.227 0 013.3 0c1.135.513-.982 5.979-3.514 4.8a2.291 2.291 0 01-1.386-1.335z",
    fill: "none",
    stroke: "#040405",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 245",
    d: "M15.267 75.232a1.61 1.61 0 01-.056-.473 3.581 3.581 0 01.61-1.712 4.451 4.451 0 011.046-1.28 3.229 3.229 0 013.3 0c1.136.513-.982 5.98-3.514 4.8a2.286 2.286 0 01-1.386-1.335z",
    fill: "none",
    stroke: "#040405",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 246",
    d: "M87.632 71.415a1.684 1.684 0 01-.056-.473 3.571 3.571 0 01.611-1.712 4.433 4.433 0 011.046-1.28 3.227 3.227 0 013.3 0c1.136.513-.981 5.98-3.513 4.8a2.285 2.285 0 01-1.388-1.335z",
    fill: "none",
    stroke: "#040405",
    strokeMiterlimit: 10
  }))));
}

export default __webpack_public_path__ + "3235067036ca3bf63b54cf509bf9a25a.svg";
export { SvgIconSlope as ReactComponent };